export default __webpack_public_path__ + "static/media/OKAFuturaBook.9d67e2b2.ttf";